export const APP_CONFIG = {
  system_type: 'deposit',
  baseDomain: process.env.VUE_APP_ENDPOINT,
  baseDomainDeposit: process.env.VUE_APP_ENDPOINT,
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://thongtintmdt.com',
    main_domain_deposit: 'https://thongtintmdt.com',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/viettaobao-oee.appspot.com/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 3600
};
